import { createWebPersistentAtom } from "./persistent"

export const $refCode = createWebPersistentAtom<string | null>("refCode", null)

export const setRefCode = (code: string | null) => {
  $refCode.set(code)
}

export const resetRefCode = () => {
  $refCode.set(null)
}
